import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';
import {
  CfdiUsesResponse,
  FiscalRegimensResponse,
} from '../model/fiscal/FiscalDto';

export async function getFiscalRegimes(): Promise<FiscalRegimensResponse> {
  const endpoint = endpoints.fiscal.getFiscalRegimes;
  return await axiosV2.get<FiscalRegimensResponse>(endpoint);
}

export async function getCfdiUses(): Promise<CfdiUsesResponse> {
  const endpoint = endpoints.fiscal.getCfdiUses;
  return await axiosV2.get<CfdiUsesResponse>(endpoint);
}
